module.exports = __webpack_public_path__ + "static/media/gelan-small.945e87bb.webp";